"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var arrayExtensions_1 = require("spry-react/utils/arrayExtensions");
var TransitionGroup = /** @class */ (function (_super) {
    __extends(TransitionGroup, _super);
    function TransitionGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.childRefs = {};
        _this.state = {
            time: null,
            children: props.data.map(function (child) {
                return {
                    key: child.key,
                    data: child,
                    styleDefinition: null,
                    animatedStyle: null,
                    isEntering: false,
                    isExiting: false
                };
            })
        };
        return _this;
    }
    TransitionGroup.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        this.setState(function (prevState) {
            var merged = _this.merge(prevState.children, nextProps.data, _this.props.willEnter || (function (item) { return null; }), _this.props.willExit || (function (item, element) { return null; }));
            return { children: merged };
        });
    };
    TransitionGroup.prototype.merge = function (oldList, newList, onEnter, onExit) {
        /* begin by accepting the position of any new or existing items in the new list */
        var merged = [];
        var _loop_1 = function (i) {
            var newItem = newList[i];
            var existingTransitioningChild = arrayExtensions_1.find(oldList, function (oldItem) { return oldItem.key == newItem.key; });
            if (existingTransitioningChild != null) {
                merged.push(__assign(__assign({}, existingTransitioningChild), { data: newItem }));
            }
            else {
                var enterStyleDefinition = onEnter(newItem);
                merged.push({
                    key: newItem.key,
                    data: newItem,
                    styleDefinition: enterStyleDefinition,
                    animatedStyle: null,
                    isEntering: true,
                    isExiting: false
                });
                if (enterStyleDefinition != null && this_1.hasAnimationDefinition(enterStyleDefinition)) {
                    this_1.startAnimationIfNecessary();
                }
            }
        };
        var this_1 = this;
        for (var i = 0; i < newList.length; i++) {
            _loop_1(i);
        }
        /* for each item in the old list which is no longer in the new list, find an appropriate position,
           where appropriate is defined as before all other items it was previously before */
        var dependencies = [];
        oldList.filter(function (oldItem) { return newList.filter(function (newItem) { return newItem.key == oldItem.key; }).length == 0; })
            .forEach(function (oldItem) {
            for (var i = 0; i < dependencies.length; i++) {
                dependencies[i].dependencies.push(oldItem.key);
            }
            dependencies.push({ item: oldItem, dependencies: [] });
        });
        for (var i = 0; i < merged.length; i++) {
            var mergedKey = merged[i].key;
            /* if anything depends on the current key, insert it before it */
            for (var j = 0; j < dependencies.length; j++) {
                if (dependencies[j].dependencies.indexOf(mergedKey) >= 0) {
                    if (!dependencies[j].item.isExiting) {
                        var exitStyleDefinition = onExit(dependencies[j].item.data, this.getChildElement(dependencies[j].item));
                        if (exitStyleDefinition && this.hasAnimationDefinition(exitStyleDefinition)) {
                            merged.splice(i, 0, {
                                key: dependencies[j].item.key,
                                data: dependencies[j].item.data,
                                styleDefinition: exitStyleDefinition,
                                animatedStyle: null,
                                isEntering: false,
                                isExiting: true
                            });
                            this.startAnimationIfNecessary();
                        }
                    }
                    else {
                        merged.push(dependencies[j].item);
                    }
                    dependencies.splice(j, 1);
                    j--;
                    i++;
                }
            }
        }
        for (var i = 0; i < dependencies.length; i++) {
            if (!dependencies[i].item.isExiting) {
                var exitStyleDefinition = onExit(dependencies[i].item.data, this.getChildElement(dependencies[i].item));
                if (exitStyleDefinition && this.hasAnimationDefinition(exitStyleDefinition)) {
                    merged.push({
                        key: dependencies[i].item.key,
                        data: dependencies[i].item.data,
                        styleDefinition: exitStyleDefinition,
                        animatedStyle: null,
                        isEntering: false,
                        isExiting: true
                    });
                    this.startAnimationIfNecessary();
                }
            }
            else {
                merged.push(dependencies[i].item);
            }
        }
        return merged;
    };
    TransitionGroup.prototype.componentDidUpdate = function () {
        var _this = this;
        var updatedChildren = [];
        var anyChildrenUpdated = false;
        var shouldStartAnimation = false;
        this.state.children
            .forEach(function (child) {
            if (child.isEntering) {
                var childNode = _this.getChildElement(child);
                var styleDefinition = child.styleDefinition;
                var animatedStyle = child.animatedStyle;
                if (_this.props.didEnter) {
                    styleDefinition = _this.props.didEnter(child.data, childNode);
                    shouldStartAnimation = shouldStartAnimation || _this.hasAnimationDefinition(styleDefinition);
                    animatedStyle = null;
                }
                updatedChildren.push({
                    key: child.key,
                    data: child.data,
                    styleDefinition: styleDefinition,
                    animatedStyle: animatedStyle,
                    isEntering: false,
                    isExiting: child.isExiting
                });
                anyChildrenUpdated = true;
            }
            else {
                updatedChildren.push(child);
            }
        });
        if (shouldStartAnimation) {
            this.startAnimationIfNecessary();
        }
        if (anyChildrenUpdated) {
            this.setState({ children: updatedChildren });
        }
    };
    TransitionGroup.prototype.getChildElement = function (child) {
        var childRef = this.childRefs[this.getChildRefKey(child)];
        return ReactDOM.findDOMNode(childRef);
    };
    TransitionGroup.prototype.getChildRefKey = function (child) {
        return "child-" + child.key;
    };
    TransitionGroup.prototype.startAnimationIfNecessary = function () {
        var _this = this;
        if (this.animationId == null) {
            var step_1 = function (time) {
                var updatedChildren = [];
                var animationsStillRunning = false;
                for (var i = 0; i < _this.state.children.length; i++) {
                    var transitioningChild = _this.state.children[i];
                    if (transitioningChild.styleDefinition == null) {
                        updatedChildren.push(transitioningChild);
                    }
                    else if (transitioningChild.animatedStyle == null) {
                        updatedChildren.push(__assign(__assign({}, transitioningChild), { animatedStyle: _this.createAnimatedStyle(transitioningChild.styleDefinition, time) }));
                        animationsStillRunning = true;
                    }
                    else if (_this.isAnimatedStyleComplete(transitioningChild.animatedStyle, time)) {
                        /* note: any children who were exiting and have completed animating, are now removed */
                        if (!transitioningChild.isExiting) {
                            if (_this.props.doneEntering) {
                                var transitionedChildStyle = _this.props.doneEntering(transitioningChild.data, _this.getChildElement(transitioningChild));
                                if (transitionedChildStyle)
                                    transitioningChild = __assign(__assign({}, transitioningChild), { animatedStyle: transitionedChildStyle });
                            }
                            updatedChildren.push(transitioningChild);
                        }
                    }
                    else {
                        updatedChildren.push(transitioningChild);
                        animationsStillRunning = true;
                    }
                }
                _this.setState({ time: time, children: updatedChildren });
                if (animationsStillRunning) {
                    _this.animationId = requestAnimationFrame(step_1);
                }
                else {
                    _this.animationId = null;
                }
            };
            this.animationId = requestAnimationFrame(step_1);
        }
    };
    TransitionGroup.prototype.instanceOfAnimationDefinition = function (object) {
        return object != null && typeof (object) == "object" && 'start' in object;
    };
    TransitionGroup.prototype.instanceOfAnimation = function (object) {
        return object != null && typeof (object) == "object" && 'isComplete' in object;
    };
    TransitionGroup.prototype.hasAnimationDefinition = function (styleDefinition) {
        for (var key in styleDefinition) {
            if (styleDefinition.hasOwnProperty(key)) {
                var propertyValue = styleDefinition[key];
                if (this.instanceOfAnimationDefinition(propertyValue)) {
                    return true;
                }
            }
        }
        return false;
    };
    TransitionGroup.prototype.createAnimatedStyle = function (styleDefinition, time) {
        var animatedStyle = {};
        for (var key in styleDefinition) {
            if (styleDefinition.hasOwnProperty(key)) {
                var propertyValue = styleDefinition[key];
                if (this.instanceOfAnimationDefinition(propertyValue)) {
                    var animation = propertyValue.start(time);
                    animatedStyle[key] = animation;
                }
                else {
                    animatedStyle[key] = propertyValue;
                }
            }
        }
        return animatedStyle;
    };
    TransitionGroup.prototype.getDefaultStyle = function (styleDefinition) {
        var defaultStyle = {};
        for (var key in styleDefinition) {
            if (styleDefinition.hasOwnProperty(key)) {
                var propertyValue = styleDefinition[key];
                if (this.instanceOfAnimationDefinition(propertyValue)) {
                    defaultStyle[key] = propertyValue.getDefaultValue();
                }
                else {
                    defaultStyle[key] = propertyValue;
                }
            }
        }
        return defaultStyle;
    };
    TransitionGroup.prototype.isAnimatedStyleComplete = function (animatedStyle, time) {
        for (var key in animatedStyle) {
            if (animatedStyle.hasOwnProperty(key)) {
                var propertyValue = animatedStyle[key];
                if (this.instanceOfAnimation(propertyValue)) {
                    if (!propertyValue.isComplete(time)) {
                        return false;
                    }
                }
            }
        }
        return true;
    };
    TransitionGroup.prototype.getCurrentAnimatedStyle = function (animatedStyle, time) {
        var currentStyle = {};
        for (var key in animatedStyle) {
            if (animatedStyle.hasOwnProperty(key)) {
                var propertyValue = animatedStyle[key];
                if (this.instanceOfAnimation(propertyValue)) {
                    var currentValue = propertyValue.getCurrentValue(time);
                    currentStyle[key] = currentValue;
                }
                else {
                    currentStyle[key] = propertyValue;
                }
            }
        }
        return currentStyle;
    };
    TransitionGroup.prototype.render = function () {
        var _this = this;
        return this.state.children.map(function (transitioningChild) {
            var currentStyle = transitioningChild.animatedStyle != null
                ? _this.getCurrentAnimatedStyle(transitioningChild.animatedStyle, _this.state.time)
                : _this.getDefaultStyle(transitioningChild.styleDefinition);
            var childRef = function (node) {
                _this.childRefs[_this.getChildRefKey(transitioningChild)] = node;
                if (transitioningChild.data.childRef) {
                    transitioningChild.data.childRef(node);
                }
            };
            return _this.props.renderChild(transitioningChild.data, currentStyle, childRef);
        });
    };
    return TransitionGroup;
}(React.Component));
exports.TransitionGroup = TransitionGroup;
